export type Demands = {
  multiplier: number;
};

export const nullDemands: Demands = { multiplier: 1 };
